import { useLayoutEffect, useRef, memo } from 'react';
import { Collapse } from 'bootstrap';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import { setCollpasedSideNavbarToggle } from '../actions/collpasedSideNavbarToggle';
import { updateLocalStorage, getUserData } from '../helpers';
import { MASTER_LOGIN, PAGE_URLS, LOCAL_STORAGE_USER_DATA } from '../constants';
import hiveDeskLogoWhite from '../assets/img/hd-logo-white.png';
import hiveDeskLogoSmall from '../assets/img/hd-logo-white-small.png';
import hiveDeskLogo from '../assets/img/hd-logo-dark.svg';
import MyAccountDropdown from './MyAccountDropdown';
import OnboardingProgress from './OnboardingProgress';

const Navigation = ({ category }) => {
  const collapses = document.querySelectorAll('.navbar-nav .collapse');

  collapses.forEach((collapse) => {
    // Init collapses
    const collapseInstance = new Collapse(collapse, {
      toggle: false,
    });

    // Hide sibling collapses on `show.bs.collapse`
    collapse.addEventListener('show.bs.collapse', (e) => {
      e.stopPropagation();

      const closestCollapse = collapse.parentElement.closest('.collapse');
      const siblingCollapses = closestCollapse.querySelectorAll('.collapse');

      siblingCollapses.forEach((siblingCollapse) => {
        const siblingCollapseInstance = Collapse.getInstance(siblingCollapse);

        if (siblingCollapseInstance === collapseInstance) {
          return;
        }

        siblingCollapseInstance.hide();
      });
    });

    // Hide nested collapses on `hide.bs.collapse`
    collapse.addEventListener('hide.bs.collapse', (e) => {
      e.stopPropagation();

      const childCollapses = collapse.querySelectorAll('.collapse');

      childCollapses.forEach((childCollapse) => {
        const childCollapseInstance = Collapse.getInstance(childCollapse);

        childCollapseInstance.hide();
      });
    });
  });
  const dispatch = useDispatch();
  const checkWindowSize = () => {
    window.addEventListener('resize', (e) => {
      if (
        e.target.innerWidth > 767 &&
        getUserData('isSideNavbarCollapsedView')
      ) {
        dispatch(setCollpasedSideNavbarToggle(true));
      }
      if (
        e.target.innerWidth < 768 &&
        getUserData('isSideNavbarCollapsedView')
      ) {
        dispatch(setCollpasedSideNavbarToggle(false));
      }
    });
  };

  const ref = useRef(null);
  useLayoutEffect(() => {
    checkWindowSize();
    dispatch({ type: 'FETCHING_SIDE_NAVBAR_COLLAPSED_VIEW' });
    ref.current.style.setProperty('margin-top', '100%', '!important');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userDetails = useSelector((state) => state.userReducer);
  const timeOffDetails = useSelector((state) => state.timeOffReducer);
  const pendingRequests = useSelector((state) => state.requests);
  const permissions = useSelector((state) => state.permissionsReducer);
  const features = useSelector((state) => state.featuresReducer);

  const userData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA));
  const billingDetails = useSelector((state) => state.billingReducer);
  const currentPlan = (
    (userDetails &&
      userDetails.subscription.currentPlan !== null &&
      userDetails.subscription.currentPlan) ||
    ''
  ).toLowerCase();
  const { accountStatus } = billingDetails;
  const isFreeTrial =
    (currentPlan === 'trial' && accountStatus !== 'cancel') || false;
  const isMasterPassword =
    sessionStorage.getItem(MASTER_LOGIN) === 'true' || false;
  const { sideNavbarCollapsedView } = useSelector(
    (state) => state.collpasedSideNavbarToggle
  );
  // When menu & icon is single without submenu list
  const refs = useRef();
  const MenuWithoutSubMenuSingleInCollpasedView = ({ icon, text, link }) => (
    <>
      <li className="nav-item">
        <Link
          to={{ hash: '#' }}
          className="dropdown-toggle nav-link"
          ref={refs}
        >
          <i className={icon} />
        </Link>
        <Tippy
          placement="right"
          interactive
          interactiveBorder={20}
          content={
            <ul className="nav nav-sm flex-column">
              <li className="nav-item">
                <Link
                  to={link}
                  className="nav-link nav-link-color-grey ps-3 text-nowrap"
                >
                  {text}
                </Link>
              </li>
            </ul>
          }
          reference={refs}
          theme="light-border"
          {...(text === 'Dashboard' && {
            offset: [5],
          })}
        />
      </li>
    </>
  );

  MenuWithoutSubMenuSingleInCollpasedView.propTypes = {
    icon: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.string,
  };
  // When menu & icon with submenu list
  const refm = useRef();
  const MenuWithSubMenuInCollpasedView = ({
    icon,
    dropdownHeader,
    dropdownListItem = [],
  }) => (
    <li className="nav-item">
      <Link to={{ hash: '#' }} className="dropdown-toggle nav-link" ref={refm}>
        <i className={icon} />
      </Link>
      <Tippy
        placement="right"
        interactive
        content={
          <ul className="nav nav-sm flex-column">
            <li className="nav-item">
              <Link
                to={{ hash: '#' }}
                className="dropdown-header nav-link ps-3 pb-0 pt-0"
                style={{ fontSize: '15px', color: 'rgb(110, 132, 163)' }}
              >
                {dropdownHeader}
                <hr />
              </Link>
            </li>
            {dropdownListItem.map((item, i) => {
              let itemContent;
              if (!item.target) {
                itemContent = (
                  <Link
                    to={item.link}
                    className="nav-link nav-link-color-grey ps-3 text-nowrap"
                  >
                    {item.text}
                  </Link>
                );
              } else if (
                typeof item.link === 'string' &&
                item.link.startsWith('http')
              ) {
                itemContent = (
                  <a
                    href={item.link}
                    className="nav-link nav-link-color-grey ps-3 text-nowrap"
                    target={item.target}
                    rel="noreferrer"
                  >
                    {item.text}
                  </a>
                );
              } else {
                itemContent = (
                  <Link
                    to={item.link}
                    className="nav-link nav-link-color-grey ps-3 text-nowrap"
                    target={item.target}
                  >
                    {item.text}
                  </Link>
                );
              }
              return (
                <li className="nav-item" key={i}>
                  {itemContent}
                </li>
              );
            })}
          </ul>
        }
        reference={refm}
        theme="light-border"
      />
    </li>
  );

  MenuWithSubMenuInCollpasedView.propTypes = {
    icon: PropTypes.string,
    dropdownHeader: PropTypes.string,
    dropdownListItem: PropTypes.array,
  };
  return (
    <Navbar
      collapseOnSelect
      expand="md"
      id="sidebar"
      className={
        isFreeTrial && userDetails.freeTrialStatus
          ? `${
              sideNavbarCollapsedView
                ? 'navbar navbar-vertical navbar-vertical-sm fixed-start navbar-expand-md free-trial'
                : 'navbar-vertical fixed-left free-trial'
            }`
          : `${
              sideNavbarCollapsedView
                ? 'navbar navbar-vertical navbar-vertical-sm fixed-start navbar-expand-md'
                : 'navbar-vertical fixed-left'
            }`
      }
    >
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Brand href="#home">
        {!sideNavbarCollapsedView && (
          <img
            src={hiveDeskLogoWhite}
            alt="HiveDesk"
            className="d-none d-md-block img-fluid"
          />
        )}

        <div className="col-auto">
          {!sideNavbarCollapsedView ? (
            <Link
              to={{ hash: '#' }}
              className="d-none d-md-block img-fluid"
              onClick={() => {
                updateLocalStorage({ isSideNavbarCollapsedView: true });
                dispatch(setCollpasedSideNavbarToggle(true));
              }}
            >
              <i
                className="mdi mdi-format-indent-decrease text-white"
                style={{ fontSize: '20px', marginLeft: '16px' }}
              />
            </Link>
          ) : (
            <Link
              to={{ hash: '#' }}
              className="d-none d-md-block img-fluid position-relative bound-for-navbar-open-icon"
              onClick={() => {
                updateLocalStorage({ isSideNavbarCollapsedView: false });
                dispatch(setCollpasedSideNavbarToggle(false));
              }}
            >
              <img
                src={hiveDeskLogoSmall}
                alt="HiveDesk"
                className="d-none d-md-block img-fluid brand-hd-small-icon"
              />
              <i className="mdi mdi-format-indent-increase text-white navbar-open-icon" />
            </Link>
          )}
        </div>
        <img
          src={hiveDeskLogo}
          alt="HiveDesk"
          className="d-block d-md-none img-fluid"
        />
      </Navbar.Brand>
      <span className="d-block d-sm-none">
        <MyAccountDropdown />
      </span>
      <Navbar.Collapse
        id="basic-navbar-nav"
        className={`${
          sideNavbarCollapsedView ? 'navbar-icon-view-scroll' : ''
        }`}
      >
        {sideNavbarCollapsedView ? (
          <ul className="navbar-nav">
            {permissions && permissions.includes('dashboard_view') && (
              <MenuWithoutSubMenuSingleInCollpasedView
                icon="mdi mdi-view-dashboard"
                text="Dashboard"
                link={PAGE_URLS.DASHBOARD}
              />
            )}

            {permissions &&
              permissions.includes('track_page_view') &&
              features &&
              features.isWebTracking && (
                <MenuWithoutSubMenuSingleInCollpasedView
                  icon="mdi mdi-timelapse"
                  text="Track"
                  link={PAGE_URLS.TRACK}
                />
              )}

            {permissions && permissions.includes('timeline_view') && (
              <MenuWithoutSubMenuSingleInCollpasedView
                icon="mdi mdi-chart-timeline"
                text="Timeline"
                link={PAGE_URLS.TIMELINE}
              />
            )}

            {permissions && permissions.includes('client_manage') && (
              <MenuWithoutSubMenuSingleInCollpasedView
                icon="mdi mdi-account-multiple-outline"
                text="Clients"
                link={PAGE_URLS.CLIENTS}
              />
            )}

            <MenuWithSubMenuInCollpasedView
              icon="mdi mdi-folder-open"
              dropdownHeader="Projects"
              dropdownListItem={[
                { text: 'Active', link: PAGE_URLS.PROJECTS.ACTIVE },
                ...(permissions && permissions.includes('project_archive')
                  ? [
                      {
                        text: 'Archived',
                        link: '/projects/archived',
                      },
                    ]
                  : []),
              ]}
            />
            {permissions && permissions.includes('team_member_view') && (
              <MenuWithSubMenuInCollpasedView
                icon="mdi mdi-account-group-outline"
                dropdownHeader="Team"
                dropdownListItem={[
                  { text: 'Active Members', link: PAGE_URLS.TEAM.ACTIVE },
                  { text: 'Inactive Members', link: PAGE_URLS.TEAM.INACTIVE },
                  { text: 'Team Groups', link: PAGE_URLS.TEAM.TEAM_GROUPS },
                ]}
              />
            )}
            {features && features.isSchedulingEnabled && (
              <MenuWithSubMenuInCollpasedView
                icon="mdi mdi-timetable"
                dropdownHeader="Schedules"
                dropdownListItem={[
                  ...[
                    { text: 'Shifts', link: `${PAGE_URLS.SCHEDULING}/shifts` },
                  ],
                  ...(permissions && permissions.includes('schedule_import')
                    ? [
                        {
                          text: 'Overtime slots',
                          link: `${PAGE_URLS.SCHEDULING}/overtime-slots`,
                        },
                      ]
                    : []),
                  ...(permissions &&
                  permissions.includes('schedule_type_manage')
                    ? [
                        {
                          text: 'Types',
                          link: `${PAGE_URLS.SCHEDULING}/types`,
                        },
                      ]
                    : []),
                  ...[
                    {
                      text: 'Holidays',
                      link: `${PAGE_URLS.SCHEDULING}/holidays`,
                    },
                  ],
                  ...(permissions && permissions.includes('attendance_view')
                    ? [
                        {
                          text: 'Attendance',
                          link: `${PAGE_URLS.REPORTS}/attendance`,
                        },
                      ]
                    : []),
                  ...(permissions && permissions.includes('shrinkage_view')
                    ? [
                        {
                          text: 'Shrinkage',
                          link: `${PAGE_URLS.REPORTS}/shrinkage`,
                        },
                      ]
                    : []),
                  ...[
                    {
                      text: 'Shift Change Requests',
                      link: `${PAGE_URLS.SCHEDULE_CHANGE_REQUESTS}`,
                    },
                  ],
                ]}
              />
            )}

            <MenuWithSubMenuInCollpasedView
              icon="mdi mdi-folder-clock-outline"
              dropdownHeader="Timesheet"
              dropdownListItem={[
                ...[
                  { text: 'Detailed timesheet', link: '/timesheet/detailed' },
                ],
                ...(permissions &&
                permissions.includes('timesheet_summarized_view')
                  ? [
                      {
                        text: 'Summarized timesheet',
                        link: '/timesheet/summarized',
                      },
                    ]
                  : []),
                ...(features && features.isTimesheetApproval
                  ? [
                      {
                        text: 'View',
                        link: `/timesheet/view`,
                      },
                    ]
                  : []),
                ...(features &&
                features.isTimesheetApproval &&
                permissions &&
                permissions.includes('timesheet_approval')
                  ? [
                      {
                        text: 'Approval',
                        link: `/timesheet/approval`,
                      },
                    ]
                  : []),
                ...(permissions &&
                (permissions.includes('work_session_request_approval') ||
                  permissions.includes('work_session_request_review'))
                  ? [
                      {
                        text: `Worksession Requests (${
                          pendingRequests.data.workSessionEditRequests || 0
                        })`,
                        link: `/timesheet/change-requests`,
                      },
                    ]
                  : []),
              ]}
            />

            {(permissions && permissions.includes('time_off_settings')) ||
            (timeOffDetails && timeOffDetails.policyLength > 0) ? (
              <MenuWithSubMenuInCollpasedView
                icon="mdi mdi-timer-off"
                dropdownHeader="Time Off"
                dropdownListItem={[
                  ...(permissions.includes('time_off_settings')
                    ? [
                        {
                          text: 'Policy',
                          link: `${PAGE_URLS.TIMEOFF.POLICY}`,
                        },
                      ]
                    : []),
                  ...(permissions.includes('time_off_settings') &&
                  timeOffDetails &&
                  timeOffDetails.policyLength > 0
                    ? [
                        {
                          text: 'Types',
                          link: `${PAGE_URLS.TIMEOFF.TYPES}`,
                        },
                      ]
                    : []),
                  ...(timeOffDetails.typesLength > 0
                    ? [
                        {
                          text: `Requests ${
                            permissions.includes('time_off_settings') &&
                            `(${pendingRequests.data.timeOffRequests || 0})`
                          }`,
                          link: `${PAGE_URLS.TIMEOFF.REQUESTS}`,
                        },
                      ]
                    : []),
                ]}
              />
            ) : null}

            <MenuWithSubMenuInCollpasedView
              icon="mdi mdi-clipboard-pulse-outline"
              dropdownHeader="Activity"
              dropdownListItem={[
                ...[
                  {
                    text: 'Member Activity',
                    link: `${PAGE_URLS.ACTIVITY.MEMBER}`,
                  },
                ],
                ...(permissions && permissions.includes('activity_team_view')
                  ? [
                      {
                        text: 'Team Activity',
                        link: `${PAGE_URLS.ACTIVITY.TEAM}`,
                      },
                    ]
                  : []),
                ...(features &&
                features.isSessionMgmtEnabled &&
                permissions &&
                permissions.includes('work_session_ongoing_view')
                  ? [
                      {
                        text: 'Ongoing Sessions',
                        link: `${PAGE_URLS.ACTIVITY.ONGOING_SESSIONS}`,
                      },
                    ]
                  : []),
                ...(permissions &&
                permissions.includes('schedule_activity_report')
                  ? [
                      {
                        text: 'Scheduled Activity',
                        link: `${PAGE_URLS.SCHEDULED_ACTIVITY.MEMBER}`,
                      },
                    ]
                  : []),
                // ...(features &&
                // features.isUrlAndAppTrackingEnabled &&
                // permissions &&
                // permissions.includes('url_and_app_tracking')
                //   ? [
                //       {
                //         text: 'URLs',
                //         link: `${PAGE_URLS.ACTIVITY.URL_TRACKING}`,
                //       },
                //     ]
                //   : []),
                // ...(features &&
                // features.isUrlAndAppTrackingEnabled &&
                // permissions &&
                // permissions.includes('url_and_app_tracking')
                //   ? [
                //       {
                //         text: 'Apps',
                //         link: `${PAGE_URLS.ACTIVITY.APP_TRACKING}`,
                //       },
                //     ]
                //   : []),
              ]}
            />

            <MenuWithSubMenuInCollpasedView
              icon="mdi mdi-file-document-box-multiple-outline"
              dropdownHeader="Reports"
              dropdownListItem={[
                ...(features &&
                features.isOverTimeEnabled &&
                permissions &&
                permissions.includes('report_overtime')
                  ? [
                      {
                        text: 'Overtime report',
                        link: `/reports/overtime`,
                      },
                    ]
                  : []),
                ...(permissions && permissions.includes('screenshot_view')
                  ? [
                      {
                        text: 'Screenshot report',
                        link: `/reports/screenshot`,
                      },
                    ]
                  : []),
                ...(permissions &&
                (permissions.includes('work_session_view_chart') ||
                  permissions.includes('performance_view_chart'))
                  ? [
                      {
                        text: 'Charts',
                        link: `/reports/charts`,
                      },
                    ]
                  : []),
                // TARDY temporarily disabled, removed from the gate below:
                // || permissions.includes('tardy_approval')
                // || permissions.includes('tardy_request')
                ...(permissions && permissions.includes('adherence_report')
                  ? [
                      {
                        text: 'Adherence',
                        link: `/reports/adherence-report`,
                      },
                    ]
                  : []),
                ...(permissions && permissions.includes('schedule_import')
                  ? [
                      {
                        text: 'Overtime Commitment',
                        link: `${PAGE_URLS.REPORTS}/overtime-commitment`,
                      },
                    ]
                  : []),
                ...(permissions && permissions.includes('ucx_sprout_reports')
                  ? [
                      {
                        text: 'Sprout',
                        link: `${PAGE_URLS.REPORTS}/sprout`,
                      },
                    ]
                  : []),
                ...(permissions && permissions.includes('ucx_device_data_view')
                  ? [
                      {
                        text: 'Employee Devices',
                        link: `${PAGE_URLS.REPORTS}/employee-devices`,
                      },
                    ]
                  : []),
              ]}
            />

            {permissions &&
            [
              'custom_role_manage',
              'configuration_manage',
              'break_manage',
              'country_sites_manage',
            ].some((role) => permissions.includes(role)) ? (
              <MenuWithSubMenuInCollpasedView
                icon="mdi mdi-layers"
                dropdownHeader="Manage"
                dropdownListItem={[
                  ...(permissions && permissions.includes('custom_role_manage')
                    ? [
                        {
                          text: 'Roles and Permissions',
                          link: `/manage${PAGE_URLS.ROLES_AND_PERMISSIONS}`,
                        },
                      ]
                    : []),
                  ...(permissions &&
                  permissions.includes('country_sites_manage')
                    ? [
                        {
                          text: 'Country and Sites',
                          link: `${PAGE_URLS.COUNTRY_AND_SITES}`,
                        },
                      ]
                    : []),
                  ...(permissions && permissions.includes('break_manage')
                    ? [
                        {
                          text: 'Breaks',
                          link: `/manage/breaks`,
                        },
                      ]
                    : []),
                ]}
              />
            ) : null}

            {features &&
              features.isInvoiceEnabled &&
              permissions &&
              permissions.includes('invoice_manage') && (
                <MenuWithoutSubMenuSingleInCollpasedView
                  icon="mdi mdi-cash-usd"
                  text="Invoices"
                  link={PAGE_URLS.INVOICES}
                />
              )}

            <MenuWithSubMenuInCollpasedView
              icon="mdi mdi-shield-account-outline"
              dropdownHeader="Settings"
              dropdownListItem={[
                ...(permissions && permissions.includes('configuration_manage')
                  ? [
                      {
                        text: 'General',
                        link: `/settings/general`,
                      },
                    ]
                  : []),
                ...[
                  {
                    text: 'Profile',
                    link: `/settings/profile`,
                  },
                  {
                    text: 'Password',
                    link: `/settings/password`,
                  },
                ],
                ...(permissions && permissions.includes('billing_invoice_view')
                  ? [
                      {
                        text: 'Billing',
                        link: `/settings/billing`,
                      },
                    ]
                  : []),
                ...[
                  {
                    text: 'Teams',
                    link: `/settings/teams`,
                  },
                ],
                ...(permissions &&
                permissions.includes('email_summaries_manage')
                  ? [
                      {
                        text: 'Email summaries',
                        link: `/settings/email-summaries`,
                      },
                    ]
                  : []),

                ...(permissions && permissions.includes('integration_manage')
                  ? [
                      ...(userData &&
                      userData.integrations &&
                      userData.integrations.length > 0
                        ? [
                            {
                              text: 'Integrations',
                              link: `/settings/integration-status`,
                            },
                          ]
                        : [
                            {
                              text: 'Integrations',
                              link: `/settings/integration-list`,
                            },
                          ]),
                    ]
                  : []),
                ...(permissions && permissions.includes('configuration_manage')
                  ? [
                      {
                        text: 'Public API',
                        link: `/settings/public-api`,
                      },
                    ]
                  : []),
              ]}
            />

            {permissions && permissions.includes('activity_team_view') && (
              <MenuWithoutSubMenuSingleInCollpasedView
                icon="mdi mdi-file-document-outline"
                text="Logs"
                link={PAGE_URLS.LOGS}
              />
            )}

            <MenuWithSubMenuInCollpasedView
              icon="mdi mdi mdi-help-circle-outline mt-1"
              dropdownHeader="Help"
              dropdownListItem={[
                ...[
                  {
                    text: 'Admin Guide',
                    link: `https://www.hivedesk.com/admin-user-guide/`,
                    target: '_blank',
                  },
                  {
                    text: 'Member Guide',
                    link: `https://www.hivedesk.com/team-member-user-guide/`,
                    target: '_blank',
                  },
                  {
                    text: 'API Documentation',
                    link: `/help/public-api`,
                    target: '_blank',
                  },
                  {
                    text: 'Support',
                    link: `https://support.hivedesk.com/`,
                    target: '_blank',
                  },
                ],
              ]}
            />
            {isFreeTrial &&
              permissions &&
              permissions.includes('subscription_manage') && (
                <li className="nav-item">
                  <Link to={{ hash: '#' }} className="nav-link">
                    <Tippy
                      placement="right"
                      content={<OnboardingProgress />}
                      interactive
                      theme="light-border"
                    >
                      <i className="mdi mdi-progress-clock" />
                    </Tippy>
                  </Link>
                </li>
              )}
          </ul>
        ) : (
          <ul className="navbar-nav hd-sidebar-nav">
            {permissions && permissions.includes('dashboard_view') && (
              <li className="nav-item">
                <Link to={PAGE_URLS.DASHBOARD} className="nav-link">
                  <i className="mdi mdi-view-dashboard" /> Dashboard
                </Link>
              </li>
            )}

            {permissions &&
              permissions.includes('track_page_view') &&
              features &&
              features.isWebTracking && (
                <li className="nav-item">
                  <Link to={PAGE_URLS.TRACK} className="nav-link">
                    <i className="mdi mdi-timelapse" /> Track
                  </Link>
                </li>
              )}

            {permissions && permissions.includes('timeline_view') && (
              <li className="nav-item">
                <Link to={PAGE_URLS.TIMELINE} className="nav-link">
                  <i className="mdi mdi-chart-timeline" /> Timeline
                </Link>
              </li>
            )}

            {permissions && permissions.includes('client_manage') && (
              <li className="nav-item">
                <Link to={PAGE_URLS.CLIENTS} className="nav-link">
                  <i className="mdi mdi-account-multiple-outline" /> Clients
                </Link>
              </li>
            )}

            <li className="nav-item nav-projects">
              <a
                className="nav-link"
                href="#projects"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded={category === 'Projects'}
                aria-controls="projects"
              >
                <i className="mdi mdi-folder-open" /> Projects
              </a>
              <div
                className={
                  category === 'Projects' ? 'collapse show' : 'collapse'
                }
                id="projects"
              >
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link
                      to={PAGE_URLS.PROJECTS.ACTIVE}
                      className="nav-link nav-link-color-grey "
                    >
                      Active
                    </Link>
                  </li>
                  {permissions && permissions.includes('project_archive') && (
                    <li className="nav-item ">
                      <Link
                        to="/projects/archived"
                        className="nav-link nav-link-color-grey"
                      >
                        Archived
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </li>
            {permissions && permissions.includes('team_member_view') && (
              <li className="nav-item nav-team">
                <a
                  className="nav-link"
                  href="#team"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={category === 'Team'}
                  aria-controls="projects"
                >
                  <i className="mdi mdi-account-group-outline" /> Team
                </a>
                <div
                  className={category === 'Team' ? 'collapse show' : 'collapse'}
                  id="team"
                >
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link
                        to={PAGE_URLS.TEAM.ACTIVE}
                        className="nav-link nav-link-color-grey"
                      >
                        Active Members
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to={PAGE_URLS.TEAM.INACTIVE}
                        className="nav-link nav-link-color-grey"
                      >
                        Inactive Members
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to={PAGE_URLS.TEAM.TEAM_GROUPS}
                        className="nav-link nav-link-color-grey"
                      >
                        Team Groups
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {features && features.isSchedulingEnabled && (
              <li className="nav-item nav-scheduling">
                <a
                  className="nav-link"
                  href="#schedules"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={category === 'Schedules'}
                  aria-controls="schedules"
                >
                  <i className="mdi mdi-timetable" /> Schedules
                </a>
                <div
                  className={
                    category === 'Schedules' ? 'collapse show' : 'collapse'
                  }
                  id="schedules"
                >
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link
                        to={`${PAGE_URLS.SCHEDULING}/shifts`}
                        className="nav-link nav-link-color-grey"
                      >
                        Shifts
                      </Link>
                    </li>
                    {permissions && permissions.includes('schedule_import') && (
                      <li className="nav-item">
                        <Link
                          to={`${PAGE_URLS.SCHEDULING}/overtime-slots`}
                          className="nav-link nav-link-color-grey"
                        >
                          Overtime Slots
                        </Link>
                      </li>
                    )}
                    {permissions &&
                      permissions.includes('schedule_type_manage') && (
                        <li className="nav-item">
                          <Link
                            to={`${PAGE_URLS.SCHEDULING}/types`}
                            className="nav-link nav-link-color-grey"
                          >
                            Types
                          </Link>
                        </li>
                      )}
                    <li className="nav-item">
                      <Link
                        to={`${PAGE_URLS.SCHEDULING}/holidays`}
                        className="nav-link nav-link-color-grey"
                      >
                        Holidays
                      </Link>
                    </li>
                    {permissions && permissions.includes('attendance_view') && (
                      <li className="nav-item">
                        <Link
                          to={`${PAGE_URLS.REPORTS}/attendance`}
                          className="nav-link nav-link-color-grey"
                        >
                          Attendance
                        </Link>
                      </li>
                    )}
                    {permissions && permissions.includes('shrinkage_view') && (
                      <li className="nav-item">
                        <Link
                          to={`${PAGE_URLS.REPORTS}/shrinkage`}
                          className="nav-link nav-link-color-grey"
                        >
                          Shrinkage
                        </Link>
                      </li>
                    )}
                    <li className="nav-item">
                      <Link
                        to={`${PAGE_URLS.SCHEDULE_CHANGE_REQUESTS}`}
                        className="nav-link nav-link-color-grey"
                      >
                        Shift Change Requests
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}

            <li className="nav-item nav-timesheet">
              <a
                className="nav-link"
                href="#timesheet"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded={category === 'Timesheet'}
                aria-controls="timesheet"
              >
                <i className="mdi mdi-folder-clock-outline" /> Timesheet
              </a>
              <div
                className={
                  category === 'Timesheet' ? 'collapse show' : 'collapse'
                }
                id="timesheet"
              >
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link
                      to="/timesheet/detailed"
                      className="nav-link nav-link-color-grey"
                    >
                      Detailed timesheet
                    </Link>
                  </li>

                  {permissions &&
                    permissions.includes('timesheet_summarized_view') && (
                      <li className="nav-item">
                        <Link
                          to="/timesheet/summarized"
                          className="nav-link nav-link-color-grey"
                        >
                          Summarized timesheet
                        </Link>
                      </li>
                    )}

                  {features && features.isTimesheetApproval && (
                    <>
                      <li className="nav-item">
                        <Link
                          to="/timesheet/view"
                          className="nav-link nav-link-color-grey"
                        >
                          View
                        </Link>
                      </li>
                      {permissions &&
                        permissions.includes('timesheet_approval') && (
                          <li className="nav-item">
                            <Link
                              to="/timesheet/approval"
                              className="nav-link nav-link-color-grey"
                            >
                              Approval
                            </Link>
                          </li>
                        )}
                    </>
                  )}
                  {permissions &&
                    (permissions.includes('work_session_request_approval') ||
                      permissions.includes('work_session_request_review')) && (
                      <li className="nav-item">
                        <Link
                          to="/timesheet/change-requests"
                          className="nav-link nav-link-color-grey"
                        >
                          Worksession Requests (
                          {pendingRequests.data.workSessionEditRequests || 0})
                        </Link>
                      </li>
                    )}
                </ul>
              </div>
            </li>
            {(permissions && permissions.includes('time_off_settings')) ||
            (timeOffDetails && timeOffDetails.policyLength > 0) ? (
              <li className="nav-item nav-timeoff">
                <a
                  className="nav-link"
                  href="#timeOff"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={category === 'Time Off'}
                  aria-controls="timeOff"
                >
                  <i className="mdi mdi-timer-off" /> Time Off
                </a>
                <div
                  className={
                    category === 'Time Off' ? 'collapse show' : 'collapse'
                  }
                  id="timeOff"
                >
                  <ul className="nav nav-sm flex-column">
                    {permissions.includes('time_off_settings') && (
                      <li className="nav-item">
                        <Link
                          to={`${PAGE_URLS.TIMEOFF.POLICY}`}
                          className="nav-link nav-link-color-grey"
                        >
                          Policy
                        </Link>
                      </li>
                    )}

                    {permissions.includes('time_off_settings') &&
                      timeOffDetails &&
                      timeOffDetails.policyLength > 0 && (
                        <li className="nav-item">
                          <Link
                            to={`${PAGE_URLS.TIMEOFF.TYPES}`}
                            className="nav-link nav-link-color-grey"
                          >
                            Types
                          </Link>
                        </li>
                      )}
                    {timeOffDetails &&
                      timeOffDetails.policyLength > 0 &&
                      timeOffDetails.typesLength > 0 && (
                        <li className="nav-item">
                          <Link
                            to={`${PAGE_URLS.TIMEOFF.REQUESTS}`}
                            className="nav-link nav-link-color-grey"
                          >
                            Requests{' '}
                            {permissions.includes('time_off_settings') &&
                              `(${pendingRequests.data.timeOffRequests || 0})`}
                          </Link>
                        </li>
                      )}
                  </ul>
                </div>
              </li>
            ) : null}

            <li className="nav-item nav-activity">
              <a
                className="nav-link"
                href="#activity"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded={category === 'Activity'}
                aria-controls="activity"
              >
                <i className="mdi mdi-clipboard-pulse-outline" /> Activity
              </a>
              <div
                className={
                  category === 'Activity' ? 'collapse show' : 'collapse'
                }
                id="activity"
              >
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link
                      to={PAGE_URLS.ACTIVITY.MEMBER}
                      className="nav-link nav-link-color-grey"
                    >
                      Member Activity
                    </Link>
                  </li>
                  {permissions &&
                    permissions.includes('activity_team_view') && (
                      <li className="nav-item">
                        <Link
                          to={PAGE_URLS.ACTIVITY.TEAM}
                          className="nav-link nav-link-color-grey"
                        >
                          Team Activity
                        </Link>
                      </li>
                    )}
                  {features &&
                    features.isSessionMgmtEnabled &&
                    permissions &&
                    permissions.includes('work_session_ongoing_view') && (
                      <li className="nav-item">
                        <Link
                          to={PAGE_URLS.ACTIVITY.ONGOING_SESSIONS}
                          className="nav-link nav-link-color-grey"
                        >
                          Ongoing Sessions
                        </Link>
                      </li>
                    )}
                  {permissions &&
                    permissions.includes('schedule_activity_report') && (
                      <li className="nav-item">
                        <Link
                          to={PAGE_URLS.SCHEDULED_ACTIVITY.MEMBER}
                          className="nav-link nav-link-color-grey"
                        >
                          Scheduled Activity
                        </Link>
                      </li>
                    )}
                  {/* URL & App Tracking is disabled for now because this feature is not ready on Desktop client */}
                  {/* {features &&
                    features.isUrlAndAppTrackingEnabled &&
                    permissions &&
                    permissions.includes('url_and_app_tracking') && (
                      <li className="nav-item">
                        <Link
                          to={PAGE_URLS.ACTIVITY.URL_TRACKING}
                          className="nav-link nav-link-color-grey"
                        >
                          URLs
                        </Link>
                      </li>
                    )} 
                  {features &&
                    features.isUrlAndAppTrackingEnabled &&
                    permissions &&
                    permissions.includes('url_and_app_tracking') && (
                      <li className="nav-item">
                        <Link
                          to={PAGE_URLS.ACTIVITY.APP_TRACKING}
                          className="nav-link nav-link-color-grey"
                        >
                          Apps
                        </Link>
                      </li>
                    )} */}
                </ul>
              </div>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#reports"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded={category === 'Reports'}
                aria-controls="reports"
              >
                <i className="mdi mdi-file-document-box-multiple-outline" />{' '}
                Reports
              </a>
              <div
                className={
                  category === 'Reports' ? 'collapse show' : 'collapse'
                }
                id="reports"
              >
                <ul className="nav nav-sm flex-column">
                  {features &&
                    features.isOverTimeEnabled &&
                    permissions &&
                    permissions.includes('report_overtime') && (
                      <li className="nav-item">
                        <Link
                          to="/reports/overtime"
                          className="nav-link nav-link-color-grey "
                        >
                          Overtime report
                        </Link>
                      </li>
                    )}
                  {permissions && permissions.includes('screenshot_view') && (
                    <li className="nav-item">
                      <Link
                        to="/reports/screenshot"
                        className="nav-link nav-link-color-grey"
                      >
                        Screenshot report
                      </Link>
                    </li>
                  )}
                  {permissions &&
                    (permissions.includes('work_session_view_chart') ||
                      permissions.includes('performance_view_chart')) && (
                      <li className="nav-item">
                        <Link
                          to="/reports/charts"
                          className="nav-link nav-link-color-grey "
                        >
                          Charts
                        </Link>
                      </li>
                    )}
                  {/* TARDY temporarily disabled, removed from the gate below:
                      || permissions.includes('tardy_approval')
                      || permissions.includes('tardy_request') */}
                  {permissions && permissions.includes('adherence_report') && (
                    <li className="nav-item">
                      <Link
                        to="/reports/adherence-report"
                        className="nav-link nav-link-color-grey "
                      >
                        Adherence
                      </Link>
                    </li>
                  )}
                  {permissions && permissions.includes('schedule_import') && (
                    <li className="nav-item">
                      <Link
                        to={`${PAGE_URLS.REPORTS}/overtime-commitments`}
                        className="nav-link nav-link-color-grey"
                      >
                        Overtime Commitments
                      </Link>
                    </li>
                  )}
                  {permissions &&
                    permissions.includes('ucx_sprout_reports') && (
                      <li className="nav-item">
                        <Link
                          to={`${PAGE_URLS.REPORTS}/sprout`}
                          className="nav-link nav-link-color-grey "
                        >
                          Sprout
                        </Link>
                      </li>
                    )}
                  {permissions &&
                    permissions.includes('ucx_device_data_view') && (
                      <li className="nav-item">
                        <Link
                          to={`${PAGE_URLS.REPORTS}/employee-devices`}
                          className="nav-link nav-link-color-grey "
                        >
                          Employee Devices
                        </Link>
                      </li>
                    )}
                </ul>
              </div>
            </li>
            {permissions &&
            [
              'custom_role_manage',
              'configuration_manage',
              'break_manage',
              'country_sites_manage',
            ].some((role) => permissions.includes(role)) ? (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#manage"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded={category === 'Manage'}
                  aria-controls="manage"
                >
                  <i className="mdi mdi-layers" /> Manage
                </a>
                <div
                  className={
                    category === 'Manage' ? 'collapse show' : 'collapse'
                  }
                  id="manage"
                >
                  <ul className="nav nav-sm flex-column">
                    {permissions &&
                      permissions.includes('custom_role_manage') && (
                        <li className="nav-item">
                          <Link
                            to={`/manage${PAGE_URLS.ROLES_AND_PERMISSIONS}`}
                            className="nav-link nav-link-color-grey "
                          >
                            Roles and Permissions
                          </Link>
                        </li>
                      )}
                    {permissions &&
                      permissions.includes('country_sites_manage') && (
                        <li className="nav-item">
                          <Link
                            to={`${PAGE_URLS.COUNTRY_AND_SITES}`}
                            className="nav-link nav-link-color-grey "
                          >
                            Country and Sites
                          </Link>
                        </li>
                      )}
                    {permissions && permissions.includes('break_manage') && (
                      <li className="nav-item">
                        <Link
                          to="/manage/breaks"
                          className="nav-link nav-link-color-grey "
                        >
                          Breaks
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
            ) : null}

            {features &&
              features.isInvoiceEnabled &&
              permissions &&
              permissions.includes('invoice_manage') && (
                <li className="nav-item">
                  <Link to={PAGE_URLS.INVOICES} className="nav-link">
                    <i className="mdi mdi-cash-usd" /> Invoices
                  </Link>
                </li>
              )}

            <li className="nav-item">
              <a
                className="nav-link"
                href="#settings"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded={category === 'Settings'}
                aria-controls="settings"
              >
                <i className="mdi mdi-shield-account-outline" /> Settings
              </a>
              <div
                className={
                  category === 'Settings' ? 'collapse show' : 'collapse'
                }
                id="settings"
              >
                <ul className="nav nav-sm flex-column">
                  {permissions &&
                    permissions.includes('configuration_manage') && (
                      <li className="nav-item">
                        <Link
                          to="/settings/general"
                          className="nav-link nav-link-color-grey"
                        >
                          General
                        </Link>
                      </li>
                    )}
                  <li className="nav-item">
                    <Link
                      to="/settings/profile"
                      className="nav-link nav-link-color-grey"
                    >
                      Profile
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/settings/password"
                      className="nav-link nav-link-color-grey"
                    >
                      Password
                    </Link>
                  </li>
                  {permissions &&
                    permissions.includes('billing_invoice_view') && (
                      <li className="nav-item">
                        <Link
                          to="/settings/billing"
                          className="nav-link nav-link-color-grey"
                        >
                          Billing
                        </Link>
                      </li>
                    )}
                  <li className="nav-item">
                    <Link
                      to="/settings/teams"
                      className="nav-link nav-link-color-grey"
                    >
                      Teams
                    </Link>
                  </li>

                  {permissions &&
                    permissions.includes('email_summaries_manage') && (
                      <li className="nav-item">
                        <Link
                          to="/settings/email-summaries"
                          className="nav-link nav-link-color-grey"
                        >
                          Email summaries
                        </Link>
                      </li>
                    )}
                  {permissions &&
                    permissions.includes('integration_manage') && (
                      <li className="nav-item">
                        {userData &&
                        userData.integrations &&
                        userData.integrations.length > 0 ? (
                          <Link
                            to="/settings/integration-status"
                            className="nav-link nav-link-color-grey"
                          >
                            Integrations
                          </Link>
                        ) : (
                          <Link
                            to="/settings/integration-list"
                            className="nav-link nav-link-color-grey"
                          >
                            Integrations
                          </Link>
                        )}
                      </li>
                    )}
                  {permissions &&
                    permissions.includes('configuration_manage') && (
                      <li className="nav-item">
                        <Link
                          to="/settings/public-api"
                          className="nav-link nav-link-color-grey"
                        >
                          Public API
                        </Link>
                      </li>
                    )}
                </ul>
              </div>
            </li>

            {permissions && permissions.includes('activity_team_view') && (
              <li className="nav-item">
                <Link to={PAGE_URLS.LOGS} className="nav-link">
                  <i className="mdi mdi-file-document-outline" /> Logs
                </Link>
              </li>
            )}

            <li className="nav-item nav-help">
              <a
                className="nav-link"
                href="#help"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded={category === 'Help'}
                aria-controls="help"
              >
                <i className="mdi mdi-help-circle-outline mt-1" /> Help
              </a>
              <div
                className={category === 'Help' ? 'collapse show' : 'collapse'}
                id="help"
              >
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <a
                      href="https://www.hivedesk.com/admin-user-guide/"
                      className="nav-link nav-link-color-grey"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Admin Guide
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="https://www.hivedesk.com/team-member-user-guide/"
                      className="nav-link nav-link-color-grey"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Member Guide
                    </a>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/help/public-api"
                      className="nav-link nav-link-color-grey"
                      target="_blank"
                    >
                      API Documentation
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a
                      href="https://support.hivedesk.com/"
                      className="nav-link nav-link-color-grey"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Support
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            {isFreeTrial &&
              permissions &&
              permissions.includes('subscription_manage') && (
                <OnboardingProgress />
              )}
          </ul>
        )}

        <div className="mt-auto" ref={ref} />
        {isMasterPassword && (
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/changelog" className="nav-link">
                <i className="mdi mdi-clock-alert-outline" /> Changelog
                <span
                  className=" badge bg-primary capitalize"
                  style={{ marginLeft: '.3rem' }}
                >
                  v4.1.5
                </span>
              </Link>
            </li>
          </ul>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};
Navigation.propTypes = {
  category: PropTypes.string,
};

export default memo(Navigation);
